import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const OwnFarm = ({
  size,
  type,
  theme,
  className,
  dataTestId = "own-farm-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.059 2.516a.8.8 0 0 1 .75.522l.88 2.38c.41.029.94.088 1.505.173v-.805a.667.667 0 0 1 1.333 0v1.045l.01.002c1.181.253 2.196.552 2.81.783.396.149.598.574.486.966l-.514 1.794a2.184 2.184 0 1 1-3.956 1.514h-3.98a2.595 2.595 0 1 1-4.74-1.986c-.03-.068-.068-.15-.11-.24-.174-.384-.42-.92-.559-1.266a.795.795 0 0 1 .221-.902c.21-.18.499-.394.792-.584.164-.106.344-.215.524-.308l.463-3.088H7.06ZM2.665 7.93a50.626 50.626 0 0 1-.297-.661c.107-.08.225-.16.345-.239.26-.168.484-.288.621-.335l.382-.132.407-2.714h2.565l1.054 2.85v2.858H6.384a2.595 2.595 0 0 0-3.72-1.627Zm6.41 1.627V6.791c.619.066 1.423.183 2.182.346.857.184 1.607.389 2.154.565l-.24.84a2.183 2.183 0 0 0-2.54 1.015H9.075Zm-6.459.667a1.26 1.26 0 1 0 2.52 0 1.26 1.26 0 0 0-2.52 0Zm9.066.408a.85.85 0 1 0 1.7 0 .85.85 0 0 0-1.7 0Z"
    />
  </SVGIcon>
);
